import { useSelector, useDispatch } from "react-redux";
import { makeTimeStamp } from "../utility/makeTimes";
import _ from 'underscore';
import Biscuit from "../../../../utils/Biscuit";

const uuid = _.uniqueId;

const useAddNewPeriod = ({ currentLocation, currentPrice, select }) => {

  const dispatch = useDispatch();
  const periods = useSelector(data => data.checkInTimes);

  // upong clicking new period template will be added to the dom, current version allows only one period to be present before being saved
  const handleClick = e => {

    if (
        (typeof currentLocation === 'undefined' ||
            currentLocation === null ||
            currentLocation === "") && (typeof currentPrice === 'undefined' || currentPrice === null && currentPrice === "") ||
        periods.changes.newPeriods.length > 0 ||
        periods.changes.patchPeriods.length > 0
    ) {
      return;
    }

    e.preventDefault();
    if (currentLocation && (select === 'set' || select === 'location')) {
      dispatch({
        type: "ADD_PERIOD",
        period: {
          location_id: periods.citiesReducer.filter(
              city => city.id === currentLocation
          )[0].id,
          client_id: Biscuit.get('user.client_id'),
          check_in_hours: [],
          valid_from: makeTimeStamp(periods.changes.newPeriods.slice(-1)[0]),
          type: "period",
          id: "fakeID-" + uuid()
        }
      });
    } else {
      dispatch({
        type: "ADD_PERIOD",
        period: {
          pricetariff_id: periods.pricesReducer.filter(
              price => price.id === currentPrice
          )[0].id,
          check_in_hours: [],
          client_id: Biscuit.get('user.client_id'),
          valid_from: makeTimeStamp(periods.changes.newPeriods.slice(-1)[0]),
          type: "period",
          id: "fakeID-" + uuid()
        }
      });
    }

  }

  return {
    handleClick,
    periods
  };
};

export default useAddNewPeriod;
